import {memo, ReactElement} from 'react';
import skillsJson from 'static_configs/skills.json';
import {SkillsContent} from 'types';

const content = skillsJson as SkillsContent;

function SkillsSection(): ReactElement {
  return (
    <div className="section-inner skills-root">
      <div className="section-heading compact">
        <p className="eyebrow">{content.eyebrow}</p>
        <h2>{content.title}</h2>
        <p>{content.subtitle}</p>
      </div>

      <div className="skills-categories-root">
        {content.categories.map((category) => (
          <div className="category-root" key={category.id}>
            <article className="category-card">
              <div className="card-head">
                <h3>{category.title}</h3>
              </div>
              <div className="card-content">
                {category.skills.map((skill) =>
                  <span key={`${category.id}-${skill}`} className="skill-item">{skill}</span>
                )}
              </div>
            </article>
          </div>
        ))}
      </div>
    </div>
  );
}

export const Skills = memo(SkillsSection);
